module.exports = __webpack_public_path__ + "img/pro-ERP2.de038c8d.jpg";